import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Spin, Alert } from 'antd';
import authService from '../../../Services/authService';
import Breadcrumb from "../Breadcrumb/Breadcrumb";

const EditCountry = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [formData, setFormData] = useState({ country_name: '', Is_Active: true });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [errors, setErrors] = useState({});

  // Handle input changes
  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  // Form validation
  const FormValidate = () => {
    const errors = {};
    const countryreg = /^[a-z A-Z]+$/;

    if (!formData.country_name) {
      errors.country_name = 'Country name is required';
    } else if (!countryreg.test(formData.country_name)) {
      errors.country_name = 'Country should contain only letters';
    }

    return errors;
  };

  // Handle form submission
  const handleSubmit = async (event) => {
    event.preventDefault();
    const validationErrors = FormValidate(formData);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      const token = authService.getCurrentadmin().token;

      try {
        setLoading(true);
        const response = await fetch(`${authService.getApiUrl()}countries/${id}`, {
          method: 'PUT',
          body: JSON.stringify({
            country_name: formData.country_name,
            Is_Active: formData.Is_Active ? "A" : "I",
          }),
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json; charset=UTF-8',
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          const error = await response.json();
          throw new Error(error.message || 'Error updating country');
        }

        const result = await response.json();
        console.log('Country updated:', result);
        navigate('/admin/countries');
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    }
  };

  // Load country data
  useEffect(() => {
    const loadCountry = async () => {
      const token = authService.getCurrentadmin().token;

      try {
        setLoading(true);
        const response = await fetch(`${authService.getApiUrl()}countries/${id}`, {
          method: 'GET',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json; charset=UTF-8',
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          const error = await response.json();
          throw new Error(error.message || 'Error fetching country data');
        }

        const result = await response.json();
        if (result && result.country_name) {
          setFormData({
            country_name: result.country_name || '',
            Is_Active: result.Is_Active === 'A', // Convert from 'A'/'I' to boolean
          });
        } else {
          throw new Error('Unexpected response structure: ' + JSON.stringify(result));
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    loadCountry();
  }, [id]);

  return (
    <div className='main-container'>
      <div className='container-fluid'>
        <Breadcrumb />
        <div className='category-table'>
          <div className='flex-cont add-cat'>
            <div className='heading'>
              <h3>Edit Country</h3>
            </div>
          </div>
          <div className="card">
            <div className="card-body custom-edit-service">
              {loading && <Spin tip="Loading..." />}
              {error && <Alert message="Error" description={error} type="error" showIcon />}
              <form className="needs-validation clearfix" onSubmit={handleSubmit}>
                <div className="addtest-fields mb-3">
                  <div className="flex-cont">
                    <div className="half-cont">
                      <div className="form-group">
                        <label>
                          Country Name <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="country_name"
                          value={formData.country_name}
                          onChange={handleInputChange}
                        />
                        {errors.country_name && <span className='error-message'>{errors.country_name}</span>}
                      </div>
                    </div>

                    <div className="full-cont special-case-cont">
                      <div className='form-group'>
                        <label className="custom-checkbox">
                          <input
                            type="checkbox"
                            name="Is_Active"
                            checked={formData.Is_Active}
                            onChange={handleInputChange}
                          />
                          <span className="checkmark"></span>
                          <label>Status</label>
                        </label>
                        {errors.Is_Active && <span className="error-message">{errors.Is_Active}</span>}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="submit-section">
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={loading}
                    className="btn btn-primary submit-btn"
                  >
                    Submit
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditCountry;
